import { BrowserRouter as Router} from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Box } from '@mui/material';
import Header from './componants/Header';
import Footer from './componants/Footer';
import FloatingButtons from './componants/FloatingButtons';

import Home from './pages/Home';

const theme = createTheme({
  palette: {
    primary: {
      main: 'rgba(30, 91, 92, 1)',
    },
    secondary: {
      main: '#f50057',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          height: '100%',
          overflowX: 'hidden',
          overflowY: 'auto',
          WebkitOverflowScrolling: 'touch'
        },
        body: {
          height: '100%',
          overflowX: 'hidden',
          overflowY: 'auto'
        }
      }
    }
  }
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', overflowX: 'hidden' }}>
          <Header />
          <div id="home"><Home/></div>
          <Footer />
          <FloatingButtons />

        </Box>
      </Router>
    </ThemeProvider>
  );
}

export default App;
